<template>
  <div>
    <h1>Test - {{name}}</h1>
    <div v-for="(question, index) in questions" :key="index">
      Title for - {{question.name}}
      <div class="vx-row">
        <div class="vx-col md:w-1/4">
          <vue-upload-multiple-image
            :ref="'test-reference-'+index"
            :idUpload="'test-'+index"
            :popupText="$t('labels.guidance_images')"
            :dragText="$t('labels.browse_images')"
            primaryText
            browseText
            markIsPrimaryText
            multiple
            :data-images="question.answer"
            @upload-success="uploadImageSuccess"
            @before-remove="beforeRemove"
            @edit-image="editImage"
          ></vue-upload-multiple-image>
        </div>
      </div>
    </div>
    <button @click="kishen">Submit</button>
  </div>
</template>

<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  components: {
    VueUploadMultipleImage
  },
  data() {
    return {
      name: "aaaa",
      questions: [
        {
          name: "one"
          // answer: [
          //   {
          //     path: "https://dummyimage.com/600x400/ff0/000",
          //     default: 1,
          //     highlight: 1,
          //     caption: "caption to display. receive" // Optional
          //   }
          // ]
        },
        {
          name: "two"
          // answer: [
          //   {
          //     path: "https://dummyimage.com/600x400/f00/000",
          //     default: 1,
          //     highlight: 1,
          //     caption: "caption to display. receive" // Optional
          //   }
          // ]
        }
      ],
      test: ""
    };
  },
  methods: {
    uploadImageSuccess(formData, index, fileList) {
      fileList[index].s3_url = "some test url for index : " + index;
    },
    beforeRemove(index, done, fileList) {
      var r = confirm("remove image");
      if (r == true) {
        done();
      } else {
        console.log("cancelled");
      }
    },
    editImage(formData, index, fileList) {},
    kishen() {
      this.questions.forEach((question, index) => {
        var name = "test-reference-" + index;
        var images = this.$refs[name][0].images;
        question.answer = images.map(image => {
          return image.s3_url;
        });
      });
    }
  }
};
</script>
